export default {
  sections: {
    state: {
      title: 'État',
      fields: {
        pickup_visible: {
          label: 'Retrait visible',
        },
        has_pickup: {
          label: 'Retrait',
        },
      },
    },
    scheduled_orders: {
      title: 'Commandes planifiées',
      fields: {
        has_scheduled_orders: {
          label: "Autorisez-vous vos clients à commander à l'avance pour des horaires précis ?",
        },
        min_schedule_ahead_time_pickup: {
          label: "Délai minimum (minutes) à l'avance pour planifier des commandes en <strong>retrait</strong>",
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Dernière heure possible pour commander en <strong>retrait</strong> (minutes avant la fermeture)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Temps de préparation pour les commandes en retrait',
      fields: {
        average_order_preparation_time_min: {
          label: 'Temps de préparation en minutes',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'à',
          placeholder: 'Optionnel',
        },
      },
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    at_least_one_order_method_required:
      'Au moins 1 méthode de commande (planifiée ou immédiate) doit être activée. Vous ne pouvez pas désactiver les deux.',
  },
};
